import * as React from 'react'
import styled from 'styled-components'
import { containerDefault } from '../../lib/styles/Container'

import { ContactPersonsItem } from './ContactPersonsItem'
import { ContactPersonsProps } from './types'
import { sbEditable } from '@storyblok/storyblok-editable'

const Wrapper = styled.div`
  ${containerDefault}
  margin: 3rem auto;
  display: grid;
  gap: 4rem 2rem;
  grid-template-columns: repeat(4, 1fr);

  @media screen and (max-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 3rem 1.5rem;
  }

  @media screen and (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 480px) {
    gap: 2rem 1rem;
  }
`

export const ContactPersons = ({ blok }: ContactPersonsProps) => {
  const { contactPersonsItems } = blok

  return (
    <Wrapper {...sbEditable(blok)}>
      {contactPersonsItems?.map(personBlok => (
        <ContactPersonsItem key={personBlok._uid} blok={personBlok} />
      ))}
    </Wrapper>
  )
}
